import axios from "axios";
import { API_URL } from "@/config";

const base = `${API_URL}/salvage`;

// ─── Auth ──────────────────────────────────────────────────────────────────
export const loginSalvage = (email: string, password: string) =>
    axios.post(`${base}/auth/login`, { email, password }, { withCredentials: true });

export const logoutSalvage = () =>
    axios.post(`${base}/auth/logout`, {}, { withCredentials: true });

export const getCurrentSalvage = () =>
    axios.get(`${base}/auth/me`, { withCredentials: true });

// ─── Salvage Company ───────────────────────────────────────────────────────
export const getSalvageStats = () =>
    axios.get(`${base}/stats`, { withCredentials: true }).then((r) => r.data);

export const listAvailableVehicles = () =>
    axios.get(`${base}/vehicles`, { withCredentials: true }).then((r) => r.data);

export const placeBid = (vin: string, bid_amount: number, dealer_id?: number) =>
    axios.post(`${base}/vehicles/${vin}/bid`, { bid_amount, dealer_id }, { withCredentials: true }).then((r) => r.data);

export const getMyBids = () =>
    axios.get(`${base}/my-bids`, { withCredentials: true }).then((r) => r.data);

// ─── Dealer ────────────────────────────────────────────────────────────────
export const getDealerSalvageBids = () =>
    axios.get(`${base}/dealer/bids`, { withCredentials: true }).then((r) => r.data);

export const respondToBid = (bidId: number, status: "accepted" | "rejected") =>
    axios.patch(`${base}/dealer/bids/${bidId}`, { status }, { withCredentials: true }).then((r) => r.data);

export const getLinkedSalvageCompanies = () =>
    axios.get(`${base}/dealer/partners`, { withCredentials: true }).then((r) => r.data);

// ─── Admin ─────────────────────────────────────────────────────────────────
export const adminListSalvageCompanies = () =>
    axios.get(`${API_URL}/admin/salvage/companies`, { withCredentials: true }).then((r) => r.data);

export const adminCreateSalvageCompany = (data: {
    company_name: string; company_code: string; email: string; password: string;
    phone?: string; contact_name?: string; license_states?: string;
    license_number?: string; notes?: string;
}) => axios.post(`${API_URL}/admin/salvage/companies`, data, { withCredentials: true }).then((r) => r.data);

export const adminUpdateSalvageStatus = (id: number, status: string) =>
    axios.patch(`${API_URL}/admin/salvage/companies/${id}/status`, { status }, { withCredentials: true }).then((r) => r.data);
